export function agencyDescriptionandOptionLILLARDREALTYGROUP() {
return [   // Release 2026-03-18 14:27:38
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 1,
   name: "Checkbox SellersAgent", 
   isText: false,
   type: "checkbox",
   top: 250.44,
   left: 72,
   width: 10.32,
   height: 9.24
}
,
{
   page: 1,
   name: "Signature Initials SellersAgent Seller1", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 247.68,
   left: 201.96,
   width: 30.00,
   height: 13.32
}
,
{
   page: 1,
   name: "Signature Initials SellersAgent Seller2", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 247.68,
   left: 237.96,
   width: 24.00,
   height: 13.32
}
,
{
   page: 1,
   name: "Signature SellersAgent Seller1", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 318.329,
   left: 151.928,
   width: 191.236,
   height: 12.836
}
,
{
   page: 1,
   name: "Date SellersAgent Seller1", 
   fontSize: 9,
   type: "date",
   top: 317.28,
   left: 373.32,
   width: 72.00,
   height: 13.32
}
,
{
   page: 1,
   name: "Signature SellersAgent Seller2", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 332.129,
   left: 151.928,
   width: 191.236,
   height: 12.836
}
,
{
   page: 1,
   name: "Date SellersAgent Seller2", 
   fontSize: 9,
   type: "date",
   top: 331.44,
   left: 373.32,
   width: 72.00,
   height: 13.08
}
,
{
   page: 1,
   name: "Checkbox TransactionBroker", 
   isText: false,
   type: "checkbox",
   top: 392.04,
   left: 72,
   width: 10.32,
   height: 9.24
}
,
{
   page: 1,
   name: "Signature Initials TransactionBroker Seller1", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 389.28,
   left: 228.96,
   width: 30.00,
   height: 13.32
}
,
{
   page: 1,
   name: "Signature Initials TransactionBroker Seller2", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 389.28,
   left: 264.96,
   width: 24.00,
   height: 13.32
}
,
{
   page: 1,
   name: "Signature TransactionBroker Seller1", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 472.529,
   left: 151.928,
   width: 191.236,
   height: 12.837
}
,
{
   page: 1,
   name: "Date TransactionBroker Seller1", 
   fontSize: 9,
   type: "date",
   top: 472.56,
   left: 373.32,
   width: 72.00,
   height: 13.32
}
,
{
   page: 1,
   name: "Signature TransactionBroker Seller2", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 487.329,
   left: 151.928,
   width: 191.236,
   height: 12.837
}
,
{
   page: 1,
   name: "Date TransactionBroker Seller2", 
   fontSize: 9,
   type: "date",
   top: 486.72,
   left: 373.32,
   width: 72.00,
   height: 13.32
}
,
{
   page: 1,
   name: "Checkbox SellersAgentTransitionTB", 
   isText: false,
   type: "checkbox",
   top: 547.32,
   left: 72,
   width: 10.32,
   height: 9.24
}
,
{
   page: 1,
   name: "Signature Initials SellersAgentTransitionTB Seller1", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 544.56,
   left: 432.72,
   width: 30.00,
   height: 13.32
}
,
{
   page: 1,
   name: "Signature Initials SellersAgentTransitionTB Seller2", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 544.56,
   left: 468.72,
   width: 24.00,
   height: 13.32
}
,
{
   page: 1,
   name: "Date SellersAgentTransitionTB Seller1", 
   fontSize: 9,
   type: "date",
   top: 669.6,
   left: 373.32,
   width: 72.00,
   height: 13.32
}
,
{
   page: 1,
   name: "Date SellersAgentTransitionTB Seller2", 
   fontSize: 9,
   type: "date",
   top: 683.76,
   left: 373.32,
   width: 72.00,
   height: 13.08
}
,
{
   page: 1,
   name: "Signature SellersAgentTransitionTB Seller1", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 669.785,
   left: 151.928,
   width: 191.236,
   height: 12.836
}
,
{
   page: 1,
   name: "Signature SellersAgentTransitionTB Seller2", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 684.312,
   left: 151.928,
   width: 191.236,
   height: 12.8365
}
] }
